//import {Row} from 'antd';
import {
  Row,
  Form,
  Input,
 
  Select,

  message,
 
} from "antd";

import classes from "../Pages.module.css";
import DataField from "./DataField";
import axios from "axios";

import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
// import DataContext from "../../../Context/dataContext";

const { Option } = Select;

const SizeDetail = (props) => {
  const { data, setData, calculateTotals } = props;
  console.log(props, "props in sizedetail");
  //   // console.log(props, "props in sizedetail");
  //   // console.log(props, "props in sizedetail");

  const [openingBalance, setOpeningBalance] = useState({ amount: 0, type: "DR" });

  // const sizeRef = useRef(null);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.transactionDate) {
      // Get the current form values
      const currentValues = form.getFieldsValue();

      // Iterate through all prodDetail fields
      currentValues.prodDetail.forEach((detail, index) => {
        if (detail.account_code1) {
          // Call handleAccountSelect for each existing account_code1
          handleAccountSelect(detail.account_code1, index);
        }
      });
    }
  }, [props.transactionDate]);


  const handleAccountSelect = async (accountCode, fieldKey) => {
    try {
      const response = await axios.get(
        'https://metalzulu-backend.onrender.com/api/v1/transport/get-transporter-details',
        {
          params: {
            transaction_date: props.transactionDate,
            transporter_code: accountCode
          },
          withCredentials: true,
        }
      );

      const openingValue = response.data.ACCOUNT_CODEH.rows[0].opening_balance;

      setOpeningBalance({
        amount: Math.abs(openingValue),
        type: openingValue < 0 ? "CR" : "DR"
      });

      form.setFieldsValue({
        prodDetail: {
          [fieldKey]: {
            opening: `${Math.abs(openingValue)} ${openingValue < 0 ? "CR" : "DR"}`
          }
        }
      });

    } catch (error) {
      console.error('Error fetching account data:', error);
      message.error('Failed to fetch account data');
    }
  };



  const handleValueChanges = (changedValues, allValues) => {
    props.setData((data) => {
      return {
        ...data,
        prodDetail: allValues.prodDetail,
        // invoiceSize1: changedValues.invoiceSize,
      };
    });
  };

  const handleVoucherDetailChange = (changedValue, changedName) => {
    console.log(changedValue, changedName);
    // Check if changedValue and changedName are defined before proceeding
    // if (changedValue === undefined || changedName === undefined) {
    //   console.error("Changed value or name is undefined");
    //   return; // Exit early if either value is undefined
    // }

    // Update the specific VoucherDetail field with the new value
    setData((prevData) => {
      console.log(prevData);

      // Map over the prodDetail array and update the relevant item
      const updatedVoucherDetail = prevData.prodDetail.map((item, index) => {
        if (index === changedName) {
          return {
            ...item,
            net_amount: changedValue, // Update the 'net_amount' field for the specific item
          };
        }
        return item;
      });

      console.log(updatedVoucherDetail, "Updated Voucher Detail");

      // Calculate the new totals for credit and debit
      const { totalCr } = calculateTotals(updatedVoucherDetail);

      // Return the updated state with the new VoucherDetail and VoucherHeader
      return {
        ...prevData,
        prodDetail: updatedVoucherDetail,
        prodHdr: [
          {
            ...prevData.prodHdr[0],
            net_amount: totalCr,
          },
        ],
      };
    });
  };

  return props.editMode ? (
    <Form
      layout="vertical"
      name="filter_form"
      onValuesChange={handleValueChanges}
      autoComplete="off"
      form={form}
    >
      <div className="component-container">
        <Form.List name="prodDetail" initialValue={props.data}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }, i) => (
                  <table
                    id="table_order"
                    className="table table-bordered"
                    style={{
                      tableLayout: "fixed",
                      width: "1250px",
                      marginBottom: "-2rem",
                    }}
                  >
                    {i === 0 && (
                      <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                        <tr
                          style={{
                            height: "0.4rem",
                            backgroundColor: "rgb(217 217 217 / 35%)",
                          }}
                        >
                          <th style={{ width: "12%" }}>
                            {" "}
                            Expense Account{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>

                          <th style={{}}>
                            Opening{" "}
                            {/* <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span> */}
                          </th>
                          <th style={{}}>
                            Type{" "}
                            {/* <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span> */}
                          </th>
                          {/* <th style={{}}>
                            Cost Center{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th> */}
                          {/* <th style={{}}>Avail. Qty</th> */}
                          {/* <th style={{}}>
                            Reference Service{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th> */}

                          <th style={{}}>
                            Run Type{" "}
                            {/* <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span> */}
                          </th>
                          <th style={{}}>
                            Entry Type{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>
                          {/* <th style={{}}>Tax Rate</th>
                          <th style={{}}>Abatement %</th> */}
                          <th style={{}}>
                            Value{" "}
                            <span
                              style={{
                                backgroundColor: "rgb(217 217 217 / -0.65%)",
                                color: "red",
                              }}
                            >
                              *
                            </span>
                          </th>
                          <th style={{}}>Value For Taxable</th>
                          <th style={{}}>Running Total</th>
                          <th style={{ width: "8%", textAlign: "left" }}>#</th>
                        </tr>
                      </thead>
                    )}

                    <tbody
                    // style={{
                    //   width: "12%",
                    //   height: "10px",
                    //   // border: "2px solid black",
                    // }}
                    >
                      <tr
                        style={
                          {
                            // border: "2px solid red",
                          }
                        }
                      >
                        <td
                          style={{
                            width: "12%",
                            // height: "10px",
                            border: "1px solid white",
                          }}
                        >
                          <Form.Item
                            // style={{ border: "2px solid red" }}
                            {...restField}
                            name={[name, "account_code1"]}
                            fieldKey={[fieldKey, "account_code1"]}
                            //  label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']}></div>}
                            rules={[
                              { required: true, message: "Missing Name" },
                            ]}
                          >
                            <Select
                              // onChange={(changedValues, allValues) =>
                              //   handlechangee1(changedValues, allValues, i)
                              // }

                              bordered={true}
                              onChange={(value) => handleAccountSelect(value, fieldKey)}
                              style={{
                                width: "110%",
                                textAlign: "left",
                                float: "left",
                                backgroundColor: "white",
                                color: "#1777C4",
                                fontWeight: "bold",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              placeholder="Select Account"
                              optionFilterProp="children"
                            >
                              {props.id.rows.map((option) => {
                                return (
                                  <Option
                                    style={{
                                      textTransform: "capitalize",
                                      color: "#1777C4",
                                    }}
                                    key={option[props.id.fields[0].name]}
                                    value={option[props.id.fields[0].name]}
                                  >
                                    {option[props.id.fields[1].name]}{" "}
                                    {option[props.id.fields[0].name]}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "opening"]}

                            fieldKey={[fieldKey, "opening"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: openingBalance.type === "CR" ? "green" : "red",
                                fontWeight: "bold",
                                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              placeholder="Opening"
                              readOnly
                              value={`${openingBalance.amount} ${openingBalance.type}`}
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "charge_type"]}
                            fieldKey={[fieldKey, "charge_type"]}
                          >
                            <Select
                              bordered={true}
                              style={{
                                width: "100%",
                                textAlign: "left",
                                float: "left",
                                backgroundColor: "white",
                                color: "#1777C4",
                                fontWeight: "bold",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              placeholder="Select Grade"
                              optionFilterProp="children"
                              // onChange={(changedValues, allValues) =>
                              //   handleKeyPress(changedValues, allValues, i)
                              // }
                              // console.log(props.id.TYPE.fields[1].name)
                              value={"D"}
                            >
                              {props.id.TYPE.rows.map((option) => (
                                <Option
                                  style={{
                                    textTransform: "capitalize",
                                    color: "#1777C4",
                                  }}
                                  key={option[props.id.TYPE.fields[0].name]}
                                  value={option[props.id.TYPE.fields[0].name]}
                                >
                                  {option[props.id.TYPE.fields[1].name]}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </td>

                        {/* <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "account_code2"]}
                            fieldKey={[fieldKey, "account_code2"]}
                          >
                            <Select
                              bordered={true}
                              style={{
                                width: "100%",
                                textAlign: "left",
                                float: "left",
                                backgroundColor: "white",
                                color: "#1777C4",
                                fontWeight: "bold",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              placeholder="Select Grade"
                              optionFilterProp="children"
                              // onChange={(changedValues, allValues) =>
                              //   handleKeyPress(changedValues, allValues, i)
                              // }
                            >
                              {props.id.ref.reference.rows.map((option) => (
                                <Option
                                  style={{
                                    textTransform: "capitalize",
                                    color: "#1777C4",
                                  }}
                                  key={
                                    option[
                                      props.id.ref.reference.fields[0].name
                                    ]
                                  }
                                  value={
                                    option[
                                      props.id.ref.reference.fields[0].name
                                    ]
                                  }
                                >
                                  {
                                    option[
                                      props.id.ref.reference.fields[1].name
                                    ]
                                  }
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </td> */}

                        <td
                          style={{
                            textAlign: "right",
                            border: "1px solid white",
                          }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "run_total"]}
                            fieldKey={[fieldKey, "run_total"]}
                          >
                            <Select
                              bordered={true}
                              style={{
                                width: "100%",
                                textAlign: "left",
                                float: "left",
                                backgroundColor: "white",
                                color: "#1777C4",
                                fontWeight: "bold",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              placeholder="Select Grade"
                              optionFilterProp="children"
                            // onChange={(changedValues, allValues) =>
                            //   handleKeyPress(changedValues, allValues, i)
                            // }
                            >
                              {props.id.RUN_TYPE.rows.map((option) => (
                                <Option
                                  style={{
                                    textTransform: "capitalize",
                                    color: "#1777C4",
                                  }}
                                  key={option[props.id.RUN_TYPE.fields[0].name]}
                                  value={
                                    option[props.id.RUN_TYPE.fields[0].name]
                                  }
                                >
                                  {option[props.id.RUN_TYPE.fields[1].name]}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "entry_type"]}
                            fieldKey={[fieldKey, "entry_type"]}

                          // label={<div style={{ padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold" }} className={classes['Label']}></div>}
                          // rules={[{ required: true, message: 'Missing Name' }]}
                          >
                            <Select
                              bordered={true}
                              style={{
                                width: "100%",
                                textAlign: "left",
                                float: "left",
                                backgroundColor: "white",
                                color: "#1777C4",
                                fontWeight: "bold",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              placeholder="Select Grade"
                              optionFilterProp="children"
                            // value={"D"}
                            // onChange={(changedValues, allValues) =>
                            //   handleKeyPress(changedValues, allValues, i)
                            // }
                            >
                              {props.id.ENTRY_TYPE.rows.map((option) => (
                                <Option
                                  style={{
                                    textTransform: "capitalize",
                                    color: "#1777C4",
                                  }}
                                  key={
                                    option[props.id.ENTRY_TYPE.fields[0].name]
                                  }
                                  value={
                                    option[props.id.ENTRY_TYPE.fields[0].name]
                                  }
                                >
                                  {option[props.id.ENTRY_TYPE.fields[1].name]}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </td>

                        {/* <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "charge"]}
                            fieldKey={[fieldKey, "charge"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              placeholder="Enter Rate"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td> */}

                        {/* <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "abatement"]}
                            fieldKey={[fieldKey, "abatement"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              placeholder="Enter Rate"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td> */}

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "net_amount"]}
                            fieldKey={[fieldKey, "net_amount"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              onChange={(e) =>
                                handleVoucherDetailChange(e.target.value)
                              }
                              placeholder="Enter Rate"
                              step={0.01}
                              decimalScale={2}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "aba_on_val"]}
                            fieldKey={[fieldKey, "aba_on_val"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              // onChange={(e) =>
                              //   handleQuantityChange(i, e.target.value)
                              // }
                              bordered={true}
                              placeholder="Enter Rate"
                              step={0.01}
                              disabled={true}
                              decimalScale={2}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td>

                        <td style={{ border: "1px solid white" }}>
                          <Form.Item
                            {...restField}
                            name={[name, "total"]}
                            fieldKey={[fieldKey, "total"]}
                          >
                            <Input
                              style={{
                                width: "100%",
                                textAlign: "right",
                                backgroundColor: "white",
                                color: "#000000",

                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }}
                              bordered={true}
                              placeholder="Enter Rate"
                              step={0.01}
                              decimalScale={2}
                              disabled={true}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                        </td>
                        {/* onChange={handleChangee} */}
                        <td
                          style={{
                            border: "1px solid white",
                            // border: "2px solid red",
                            width: "8%",
                            textAlign: "left",
                          }}
                        >
                          <MinusCircleOutlined
                            className={classes["Remove"]}
                            onClick={() => {
                              setData((prevData) => {
                                const updatedVoucherDetail =
                                  prevData.prodDetail.filter(
                                    (_, index) => index !== name
                                  ); // Exclude the removed row
                                const { totalCr } =
                                  calculateTotals(updatedVoucherDetail);

                                return {
                                  ...prevData,
                                  prodDetail: updatedVoucherDetail,
                                  prodHdr: [
                                    {
                                      ...prevData.prodHdr[0],
                                      net_amount: totalCr,
                                    },
                                  ],
                                };
                              });
                              remove(name); // Remove the field visually
                            }}
                          />

                          <PlusCircleOutlined
                            className={classes["Add"]}
                            onClick={() => {
                              // Add a new row with default initial values
                              add({
                                account_code1: null,
                                charge_type: "A", // Default charge_type
                                account_code2: null,
                                run_total: "A", // Default run_total
                                entry_type: "D", // Default entry_type
                                charge: null,
                                abatement: null,
                                net_amount: null,
                                aba_on_val: null,
                                total: null,
                              });
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ))}
              </>
            );
          }}
        </Form.List>
      </div>
    </Form>
  ) : (
    <>
      {props.data.map((data, index) => {
        return (
          <div key={index}>
            <p></p>
            <Row
              className={props.editMode ? classes["RowDEX"] : classes["RowD"]}
            >
              <DataField
                editMode={false}
                lg={12}
                md={24}
                options={props.ad.ITEM_CODE}
                type="Select"
                name="Item"
                value={data.item_code}
              />
            </Row>
            <p></p>
          </div>
        );
      })}
    </>
  );
};

export default SizeDetail;
